
/**
 * las variables CSS de z-index  se encuentrane en: src/react/styles/zIndex.scss
 * 
 * existe un reducer que establece el z-index de algunos modales
 * reducer: src/react/containers/Player/reducers/modals/zIndex.reducer.js
 * modales que lo utilizan:
 * src/react/containers/Player/components/ChannelGrid/ChannelGrid.js
 * src/react/containers/Player/components/EpgTransactions/EpgTransactions.js
 * src/react/containers/Player/components/MenuSeries/components/VodTransactionsModal/VodTransactionsModal.js
 * src/react/containers/Player/components/SidePanel/SidePanel.js (panel de idionas)
 * src/react/containers/VodPlayer/components/VodMenuSeries/components/VodTransactionsModal/VodTransactionsModal.js
 * 
 */

export const z_index = {
  epg: 299,
  modalDefaultValue: 300, // bookmark, Checkout, ModalClaroPagos, modals de errro de facebook,apple,etc.
  modalVodAnonymous: 400,
  loadin: 498,
  modalConfirmationDeleteCards: 501,
  pinForm: 600,
  controlPip: 9999,
  modalPlayerInactivity: 1002,
};
